import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { sortPrescriptionParameters, PrescriptionValueUtils } from '@grandvisionhq/utils';
import { FilesList } from '../FilesList/FilesList.js';

const lineItemClassName = 'line-item-glasses-prescription';
const Row = ({ prescriptionAttributes  })=>{
    const { getLabel  } = useIntl();
    const sortedParams = sortPrescriptionParameters(Object.keys(prescriptionAttributes));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, sortedParams.map((key)=>/*#__PURE__*/ React.createElement("span", {
            className: `${lineItemClassName}__item`,
            key: key
        }, getLabel(`cart.lineItem.glasses.prescription.${key}`), ":", ' ', PrescriptionValueUtils.formatPrescriptionValue(key, prescriptionAttributes[key]))
    ));
};
const Wrapper = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("div", {
        className: classnames(lineItemClassName, className),
        "data-t": rest['data-t']
    }, children);
};
const NewPrescriptionDetails = ({ rightLens , leftLens  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: `${lineItemClassName}__group`
    }, /*#__PURE__*/ React.createElement("span", {
        className: `${lineItemClassName}__item ${lineItemClassName}__title`
    }, getLabel('common.right'), ":", ' '), /*#__PURE__*/ React.createElement(Row, {
        prescriptionAttributes: rightLens
    })), /*#__PURE__*/ React.createElement("div", {
        className: `${lineItemClassName}__group`
    }, /*#__PURE__*/ React.createElement("span", {
        className: `${lineItemClassName}__item ${lineItemClassName}__title`
    }, getLabel('common.left'), ":", ' '), /*#__PURE__*/ React.createElement(Row, {
        prescriptionAttributes: leftLens
    })));
};
const PrescriptionFileDetails = ({ pupillaryDistanceFileName , prescriptionFileName  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: `${lineItemClassName}__title`
    }, getLabel(`cart.lineItem.glasses.prescriptionFile.title`), ":", ' '), /*#__PURE__*/ React.createElement(FilesList, {
        className: `${lineItemClassName}__files-list`,
        items: [
            pupillaryDistanceFileName,
            prescriptionFileName
        ]
    }));
};
const PrescriptionMessage = ({ prescription  })=>{
    const { getLabel  } = useIntl();
    const labelKey = (prescription === null || prescription === void 0 ? void 0 : prescription.type) === 'ExistingCustomer' ? 'noPrescription' : 'emailPrescription';
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("span", {
        className: `${lineItemClassName}__title`
    }, getLabel(`cart.lineItem.glasses.${labelKey}.title`), ":", ' '), getLabel(`cart.lineItem.glasses.${labelKey}.message`));
};
const LineItemGlassesPrescription = (_param)=>{
    var { prescription , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "prescription",
        "className"
    ]);
    const wrapperProps = {
        className,
        'data-t': rest['data-t']
    };
    if ((prescription === null || prescription === void 0 ? void 0 : prescription.type) === 'PrescriptionFile' || (prescription === null || prescription === void 0 ? void 0 : prescription.type) === 'OCRPrescription') {
        const { prescriptionFile , pupillaryDistanceFile  } = prescription;
        return /*#__PURE__*/ React.createElement(Wrapper, {
            className: `${lineItemClassName}--column`
        }, /*#__PURE__*/ React.createElement(PrescriptionFileDetails, {
            pupillaryDistanceFileName: pupillaryDistanceFile,
            prescriptionFileName: prescriptionFile
        }));
    }
    if ((prescription === null || prescription === void 0 ? void 0 : prescription.type) === 'NewPrescription') {
        const { rightLens , leftLens  } = prescription;
        return /*#__PURE__*/ React.createElement(Wrapper, swcHelpers.extends({}, wrapperProps), /*#__PURE__*/ React.createElement(NewPrescriptionDetails, {
            rightLens: rightLens,
            leftLens: leftLens
        }));
    }
    if ((prescription === null || prescription === void 0 ? void 0 : prescription.type) === 'ExistingCustomer' || (prescription === null || prescription === void 0 ? void 0 : prescription.type) === 'EmailPrescription') {
        return /*#__PURE__*/ React.createElement(Wrapper, swcHelpers.extends({}, wrapperProps), /*#__PURE__*/ React.createElement(PrescriptionMessage, {
            prescription: prescription
        }));
    }
    return null;
};
var LineItemGlassesPrescription$1 = LineItemGlassesPrescription;

export { LineItemGlassesPrescription$1 as default };
//# sourceMappingURL=LineItemGlassesPrescription.js.map
